// React
import { ReactElement } from 'react';
// Modules
import { MixedCheckbox } from '@reach/checkbox';
import VisuallyHidden from '@reach/visually-hidden';
// Interface
import { CategoryFilterProps } from '@utmb/types/runner-ranking-table';
import { IconsEnum } from '@utmb/types/icons';
import { PiCategoryEnum } from '@utmb/types/enum/PiCategoryEnum';
// Design System
import { DropDown, DropDownItem } from '@utmb/design-system/dropdown/Dropdown';
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
import { PiCategoryLogo } from '@utmb/design-system/pi-category-logo/PiCategoryLogo';
import { Separator } from '@utmb/design-system/separator/Separator';
// Utils
import { rem } from '@utmb/utils/font';
// Styles
import styles from './filters.module.scss';

const CategoryFilter = (props: CategoryFilterProps): ReactElement => {
    const { currentCategory, categories, setCurrentCategory, query, fetchData } = props;

    const handleInputCategoryChange = (category: any): void => {
        setCurrentCategory(category);

        if (category !== currentCategory) {
            query.category = category;
            fetchData(query);
        }
    };

    return (
        <div className={styles.toolbar}>
            <DropDown
                className={styles.drop}
                button={({ isExpanded }) => (
                    <>
                        <Font.FuturaHeavy mobile="16" desktop="16">
                            {currentCategory}
                        </Font.FuturaHeavy>
                        <Icon
                            color={currentCategory === PiCategoryEnum.PI100M ? 'var(--utmb-color-white)' : 'var(--utmb-color-ws-primary)'}
                            variant={IconsEnum[isExpanded ? 'CHEVRON_UP' : 'CHEVRON_DOWN']}
                        />
                    </>
                )}
            >
                {Object.entries(categories).map(([key]: any, index: number) => {
                    const checked = key === currentCategory;

                    const hasSeparator = index < Object.entries(categories).length - 1;

                    return (
                        <div key={index} className={styles.item_wrapper}>
                            <DropDownItem onSelect={() => handleInputCategoryChange(key)} className={styles.item}>
                                <PiCategoryLogo height={20} piCategory={key as PiCategoryEnum} />
                                <label>
                                    <MixedCheckbox value={key} checked={true} />
                                    {checked && <Icon variant={IconsEnum.CHECKBOX} color="rgba(65, 80, 92,.8)" />}
                                    <VisuallyHidden> {key}</VisuallyHidden>
                                </label>
                            </DropDownItem>
                            {hasSeparator && <Separator color="rgba(65, 80, 92,.2)" spacing="0 auto" depth={`calc(100% - ${rem('15px')})`} />}
                        </div>
                    );
                })}
            </DropDown>
        </div>
    );
};

export default CategoryFilter;
